'use strict';

angular.module('docketbook').
  controller('selectJobController', function(jobService, $rootScope, $scope, $state, $stateParams, Restangular, accessControl, $timeout, $q) {

    // Initialise variables to be used
    $scope.jobSearch = "";
    $scope.jobSearchLoading = false;
    $scope.jobSearchList = [];
    $scope.jobSearchListFull = [];
    $scope.jobSelectCallback = null;
    $scope.listCount = 0;
    $scope.desktopSelected = [];

    $scope.query = {
      limit: 10,
      page: 1,
      order: 'jobNumber'
    };

    /***************************************/
    /***** Parent Controlled Functions *****/
    /***************************************/

    $scope.$parent.jobSelectFromParent = function(currentJob, cb) {
      $scope.jobSearch = "";
      $scope.jobSearchLoading = false;
      $scope.jobSearchList = [];
      $scope.jobExisting = currentJob;
      $scope.jobSelectCallback = cb;
      $scope.desktopSelected = [];
      if ( $stateParams.device == 'desktop' ) {
        $("#selectJobModal").fadeIn(100);
				$("input[name='selectJobInput']").focus();
      }
      $scope.loadJobList();
    }

    $scope.loadJobList = function(searchValue) {
      $scope.promise = $q(function(resolve, reject) {
        var queryParams = {};
        if ( $stateParams.device == 'desktop' ) {
          queryParams.limit = $scope.query.limit;
          queryParams.offset = $scope.query.limit * ($scope.query.page - 1);
          queryParams.sort = $scope.query.order;
        } else {
          queryParams.sort = 'jobNumber';
        }
        if ( searchValue != null && searchValue != "" ) {
          queryParams.search = searchValue;
        }
        jobService.getJobs(queryParams, function(returnObject) {
          $scope.jobSearchList = returnObject;
          if ( queryParams.offset <= 0 && returnObject.length < queryParams.limit ) {
            $scope.listCount = returnObject.length;
          } else {
            $scope.listCount = queryParams.offset + (queryParams.limit + 1);
          }
          for ( var i = 0; i < $scope.jobSearchList.length; i++ ) {
            $scope.jobSearchList[i].status = $scope.jobSearchList[i].status.charAt(0).toUpperCase() + $scope.jobSearchList[i].status.slice(1);
            if ( $scope.jobExisting && ($scope.jobSearchList[i].id == $scope.jobExisting.id) ) {
              $scope.jobSearchList[i].existing = true;
            }
          }
          resolve('Done');
        }, function(err) {
          $scope.jobSearchList = [];
          reject('Error');
        });
      });
    }


    $scope.closeJobSelectList = function() {
      $scope.jobSelectCallback(null);
      if ( $stateParams.device == 'desktop' ) {
        $("#selectJobModal").fadeOut(100);
      }
    }

    $scope.desktopSelectJobContinue = function() {
      var selected = $scope.desktopSelected[0];
      $scope.jobSelectCallback(selected);
      $("#selectJobModal").fadeOut(100);
    }

    /********************************/
    /***** Search Functionality *****/
    /********************************/

    $scope.searchJobChange = function(searchValue) {
      $scope.loadJobList(searchValue);
    }

    $scope.updateJobSearch = function(searchValue) {
      $scope.jobSearchLoading = true;
      $scope.jobSearch = searchValue;
      $scope.loadJobList();
    }

});



// WEBPACK FOOTER //
// ./src/controllers/selectors/selectJobController.js